import {useContext as $ek2uY$useContext, useState as $ek2uY$useState} from "react";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ 

var $4bJ9d = parcelRequire("4bJ9d");

var $dl5CL = parcelRequire("dl5CL");

var $aVUB5 = parcelRequire("aVUB5");

var $jMtLz = parcelRequire("jMtLz");

var $d6XIX = parcelRequire("d6XIX");

var $21tVR = parcelRequire("21tVR");
const $23fa96ebab9cc9ac$var$getHeights = function(position, tolerance = 0.1) {
    let { startHeight: startHeight, dragHeight: dragHeight, ...rest } = position;
    if (dragHeight == null) dragHeight = startHeight;
    let rng = [
        startHeight,
        dragHeight
    ];
    rng.sort();
    let [height, top_height] = rng;
    if (top_height - height < tolerance) top_height = null;
    return {
        height: height,
        top_height: top_height,
        ...rest
    };
};
const $23fa96ebab9cc9ac$var$HeightRange = function(props) {
    let { position: position, tolerance: tolerance } = props;
    if (!position) return null;
    if (tolerance == null) tolerance = 0.1;
    const val = $23fa96ebab9cc9ac$var$getHeights(position, tolerance);
    return (0, $4bJ9d.default)((0, $d6XIX.HeightRangeAnnotation), val);
};
const $23fa96ebab9cc9ac$export$b6af173e35939b8f = function(props) {
    const { paddingLeft: paddingLeft, scale: scale } = (0, $ek2uY$useContext)((0, $dl5CL.NoteLayoutContext));
    const { onCreateNote: onCreateNote } = (0, $ek2uY$useContext)((0, $jMtLz.NoteEditorContext));
    if (onCreateNote == null) return null;
    const { tolerance: tolerance } = props;
    const [notePosition, setPosition] = (0, $ek2uY$useState)(null);
    const { model: model } = (0, $ek2uY$useContext)((0, $aVUB5.ModelEditorContext));
    if (model != null) return null;
    const eventHeight = (evt)=>scale.invert(evt.nativeEvent.offsetY);
    return (0, $4bJ9d.default)("g.new-note", [
        (0, $4bJ9d.default)((0, $21tVR.default), {
            fill: "dodgerblue",
            size: 4,
            prefix: "new_"
        }),
        (0, $4bJ9d.default)((0, $dl5CL.NoteRect), {
            width: paddingLeft,
            fill: "transparent",
            padding: 0,
            style: {
                cursor: "drag"
            },
            onMouseDown (evt) {
                if (notePosition != null) return;
                return setPosition({
                    startHeight: eventHeight(evt),
                    offsetX: evt.nativeEvent.offsetX
                });
            },
            onMouseMove (evt) {
                if (notePosition == null) return;
                return setPosition({
                    ...notePosition,
                    dragHeight: eventHeight(evt)
                });
            },
            onMouseUp (evt) {
                const dragHeight = eventHeight(evt);
                const finalPos = $23fa96ebab9cc9ac$var$getHeights({
                    ...notePosition,
                    dragHeight: dragHeight
                });
                setPosition(null);
                return onCreateNote(finalPos);
            }
        }),
        (0, $4bJ9d.default)($23fa96ebab9cc9ac$var$HeightRange, {
            position: notePosition
        })
    ]);
};
$23fa96ebab9cc9ac$export$b6af173e35939b8f.defaultProps = {
    tolerance: 0.1
};


//# sourceMappingURL=new.7ef27eca.js.map
